import React from "react";

import Badge from "../ui/Badge";
import { purchaseState } from "../../static/materialLine";

const PurchaseStatusBadge = ({ status }: { status: number }) => {
  const state = purchaseState(status);

  return (
    <Badge variant="none" className={state.badgeClass}>
      {state.label}
    </Badge>
  );
};

export default PurchaseStatusBadge;
